import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealTileComponent } from './deal.tile.component';
import { LabelService } from '../../../shared/services/label.service';

@NgModule({
  imports: [CommonModule, DealTileComponent],
  exports: [DealTileComponent],
  providers: [LabelService],
})
export class DealTileModule {}
